import { render, staticRenderFns } from "./NnsManagement.vue?vue&type=template&id=1a8b3ee4"
import script from "./NnsManagement.vue?vue&type=script&lang=js"
export * from "./NnsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports